'use client';

import { ReactNode } from "react";
import { modalHide } from "./actions/modal";

export default function ModalClient({ children, identifier, active, closable, }: { children: ReactNode, identifier: string, active: boolean, closable: boolean }) {
  return (
    <div className={`${identifier}-modal ${active ? `` : `hidden`}`}
      onClick={() => closable && modalHide(identifier)}
      style={{
        position: `fixed`,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: 1000,
        justifyContent: `center`,
        alignItems: `center`,
        cursor: closable ? `pointer` : `default`,
      }}
    >
      <div
        onClick={event => event.stopPropagation()}
        className={`modal-content`}
        style={{
          cursor: `default`,
        }}
      >
        {children}
      </div>
      {closable && <div className="modal-close-button" style={{
        position: `absolute`,
        top: `.25em`,
        right: `.25em`,
        fontSize: `3em`,
        cursor: `pointer`,
        width: `1.5em`,
        height: `1.5em`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
      }}>&times;</div>}
    </div>
  );
}
